import { render } from "./StatusCard.vue?vue&type=template&id=5c320f29&scoped=true&ts=true"
import script from "./StatusCard.vue?vue&type=script&lang=ts"
export * from "./StatusCard.vue?vue&type=script&lang=ts"

import "./StatusCard.vue?vue&type=style&index=0&id=5c320f29&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c320f29"]])

export default __exports__